/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * The dashboard home. Owners, admins and coaches land on Today; everyone else
 * (members, a new owner still setting up) gets My training here.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useUserAccess, type UserAccess } from "../../hooks/useUserAccess";
import { todayRoleFor } from "../../lib/today";
import MyTrainingPage from "./MyTrainingPage";

export const landsOnToday = (access: UserAccess): boolean => todayRoleFor(access) !== null;

export default function HomePage() {
  const access = useUserAccess();
  if (access.isLoading) return null;
  if (landsOnToday(access)) return <Navigate to="today" replace />;
  return <MyTrainingPage />;
}
